import React from 'react'
import {Field, ErrorMessage} from "formik";

const TextareaField = ({form, field, label_text, helper_text, password, isDisabled, type}) => {
    return (
        <>
            <div>
                {
                    label_text&&
                    <label htmlFor="fname" className={"text-sm font-medium mb-3 inline-block"}>{label_text}</label>
                }
                <Field 
                    as={"input"}
                    type={type ? type : "text"}
                    name={field}
                    id={field}
                    disabled={isDisabled}
                    placeholder={helper_text ? helper_text : ""}
                    className={`resize-none h-[50px] disabled:bg-gray-100 disabled:cursor-not-allowed input-text ${form.touched[field] && form.errors[field] ? "input-text-error" : ""} ${form.values[field] && form.values[field].toString().length > 0 && "input-text-active"}`}
                />
                <p className="text-xs text-red-500">
                    <ErrorMessage name={field} />
                </p>
            </div>
        </>
    )
}

export default TextareaField